/**
 * 特邀会议：唤起app模式常量
 */
export const LAUNCH_MODE = {
  NOT_VALID: 0, // 无效邀请（旧版本客户端打开特邀会议邀请链接）
  MINI_PROGRAM: 1, // 小程序、公众号push
  QR_CODE: 2, // 桌面端扫码
};

/**
 * 唤起app会议种类常量
 */
export const LAUNCH_FROM = {
  NORMAL_MEETING: 1, // 普通会议
  PERIODICAL_MEETING: 2, // 周期性会议
  PMI: 3, // PMI会议
  QR_CODE: 4, // 特邀会议扫码
  MINI_PROGRAM: 5, // 特邀会议：小程序、公众号push
};

/**
 * VooV详情页常量
 */
export const VOOV_MEETING = {
  DETAIL_PREFIX: 'https://voovmeeting.com/detail.html',
  PMI_PREFIX: 'https://voovmeeting.com/pmi-detail.html',
  // 测试环境
  TEST_DETAIL_PREFIX: 'https://test.web.voovmeeting.com/detail.html',
  TEST_PMI_PREFIX: 'https://test.web.voovmeeting.com/pmi-detail.html',
  // 下载地址
  DOWNLOAD_URL: 'https://www.voovmeeting.com/download-center.html?from=1001',
  // 测试的 下载地址
  TEST_DOWNLOAD_URL: 'https://test.web.voovmeeting.com/download-center.html?from=1001',
  // 唤起页面
  APP_STORE_TRANSFER: 'https://meeting.tencent.com/df/en/launch-app.html',
};

/**
 * Tencent 详情页常量
 */
export const TENCENT_MEETING = {
  DETAIL_PREFIX: 'https://meeting.tencent.com/detail.html',
  DOWNLOAD_URL: 'https://meeting.tencent.com/download-center.html?from=1001',
  APP_STORE_TRANSFER: 'https://meeting.tencent.com/launch-app.html',
  PMI_PREFIX: 'https://meeting.tencent.com/pmi-detail.html',
};

/**
 * 跳转页面类型
 */
export const JUMP_TYPE = {
  DETAIL: 1,
  PMI: 2,
};

export const VOOV_ANRD_PKG_NAME = 'com.tencent.voov';
export const VOOV_IOS_PKG_NAME = 'com.tencent.tencentmeeting';
